// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zfhy","select":"styles_select__2fJaJ"};